import React, { Fragment, useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { Message } from "primereact/message";
import {
  API_URL,
  courseTypeOptions,
  kelompokModulOptions,
  sesiOptions,
  useAxios,
} from "../../../../utils/const";
import { useToast } from "../../../../Context/ToastContext";
import excelJS from "exceljs";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

const CreateModal = ({
  toggleModal,
  courseId,
  getCourseSessions,
  courseGroups,
  courseTopics,
  courseStudents,
  courseLecturers,
  classrooms,
}) => {
  const axiosInstance = useAxios();
  const { setToastObj } = useToast();

  const {
    register,
    control,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      courseType: {
        value: "PERKULIAHAN",
        label: "PERKULIAHAN",
      },
      kelompokModul: {
        value: 1,
        label: "Import Excel",
      },
    },
  });

  const courseType = watch("courseType");
  const kelompokModul = watch("kelompokModul");

  const [loading, setLoading] = useState(false);

  const courseGroupOptions = courseGroups.map((item) => {
    return {
      value: item.id,
      label: item.group.name,
    };
  });

  const courseTopicOptions = courseTopics.courseTopics.map((item) => ({
    value: item.id,
    label: item.topic,
  }));

  const classroomOptions = classrooms.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const courseLecturerOptions = courseLecturers
    .flatMap((item) =>
      item.courseGroupLecturers.map((lecturer) => ({
        value: lecturer.lecturer.id,
        label: lecturer.lecturer.name,
      }))
    )
    .filter(
      (option, index, self) =>
        index === self.findIndex((o) => o.value === option.value)
    );

  const courseStudentOptions = courseStudents.flatMap((item) =>
    item.courseGroupStudents.map((student) => ({
      value: student.student.id,
      label: `${student.student.nim} - ${student.student.name}`,
    }))
  );

  const closeModal = () => {
    toggleModal(false);
  };

  const handleSave = async (formData) => {
    setLoading(true);

    if (
      (formData.courseType.value === "TUTORIAL" ||
        formData.courseType.value === "KKD") &&
      kelompokModul.value == 1
    ) {
      await importExcel(formData);
    } else {
      let students = [];
      let sesi;
      if (formData.courseType.value === "TUTORIAL") {
        students = formData.courseStudents.map((item) => ({
          student_id: item.value,
        }));
        sesi = formData.sesi.value;
      } else if (formData.courseType.value === "KKD") {
        students = formData.courseStudents.map((item) => ({
          student_id: item.value,
        }));
      }

      const data = {
        course_group_id: formData.courseGroup.value,
        course_type: formData.courseType.value,
        course_topic_id: formData.courseTopic.value,
        date: formData.date,
        start_time: formData.start_time,
        end_time: formData.end_time,
        classroom_id: formData.classroom.value,
        lecturer_id: formData.courseLecturers.value,
        sesi: sesi,
        students: students,
      };

      try {
        await axiosInstance.post(`${API_URL}/course-sessions`, data);
        getCourseSessions();
        setLoading(false);
        setToastObj({ msg: "Data Berhasil ditambahkan", type: "success" });
        closeModal();
      } catch (error) {
        let errorMessage = "Terjadi kesalahan";
        if (error.response.data.msg != undefined) {
          errorMessage = `Terjadi kesalahan, ${error.response.data.msg}`;
        } else {
          errorMessage = error.message;
        }
        setLoading(false);
        setToastObj({
          msg: errorMessage,
          type: "danger",
        });
        closeModal();
      }
    }
  };

  const importExcel = async (formData) => {
    let sesi;

    if (formData.courseType.value === "TUTORIAL") {
      sesi = formData.sesi.value;
    }

    const file = formData.file[0];
    const reader = new FileReader();

    reader.onload = async (event) => {
      const workbook = XLSX.read(event.target.result, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const sheetData = XLSX.utils.sheet_to_json(sheet);

      const data = {
        course_group_id: formData.courseGroup.value,
        course_type: formData.courseType.value,
        course_topic_id: formData.courseTopic.value,
        date: formData.date,
        start_time: formData.start_time,
        end_time: formData.end_time,
        classroom_id: formData.classroom.value,
        sesi: sesi,
        students_lecturers: sheetData,
      };

      // Upload to Backend
      try {
        await axiosInstance.post(
          `${API_URL}/course-sessions/import-excel/tutor-kkd`,
          data
        );
        getCourseSessions();
        setLoading(false);
        setToastObj({ msg: "Data Berhasil ditambahkan", type: "success" });
        closeModal();
      } catch (error) {
        let errorMessage = "Terjadi kesalahan";
        if (error.response.data.msg != undefined) {
          errorMessage = `Terjadi kesalahan, ${error.response.data.msg}`;
        } else {
          errorMessage = error.message;
        }
        setLoading(false);
        setToastObj({
          msg: errorMessage,
          type: "danger",
        });
        closeModal();
      }
    };
    reader.readAsBinaryString(file);
  };

  const unduhTemplate = async () => {
    // Create a new workbook
    const workbook = new excelJS.Workbook();
    // New Worksheet
    const worksheet = workbook.addWorksheet(
      "Kelompok Tutor KKD Template Excel"
    );
    // Column for data in excel. key must match data key
    worksheet.columns = [
      { header: "NIDN", key: "nidn", width: 10 },
      { header: "NAMA_DOSEN", key: "nama_dosen", width: 10 },
      { header: "NIM", key: "nim", width: 10 },
      { header: "NAMA_MAHASISWA", key: "nama_mahasiswa", width: 10 },
    ];

    // Making first line in excel bold
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
    });

    const buf = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buf], { type: "application/octet-stream" }),
      "Kelompok Tutor KKD Template Excel.xlsx"
    );
  };

  return (
    <Modal show={toggleModal} onHide={closeModal} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>
          <h6>Tambah Pertemuan</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* COURSE GROUP */}
        <div className="row mb-3">
          <div className="col-md-4">
            <div className="form-group">
              <label className="form-label">Kelompok</label>
              <Controller
                control={control}
                name="courseGroup"
                rules={{ required: "-- Pilih Salah Satu --" }}
                render={({ field }) => (
                  <Select
                    value={field.value}
                    options={courseGroupOptions}
                    onChange={(value) => field.onChange(value)}
                  />
                )}
              />
              {errors.courseGroup && (
                <div className="">
                  <Message
                    className="mt-2 d-flex"
                    severity="error"
                    text={errors.courseGroup.message}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* COURSE TYPE */}
        <div className="row mb-3">
          <div className="col-md-4">
            <div className="form-group">
              <label className="form-label">Tipe Pertemuan</label>
              <Controller
                control={control}
                name="courseType"
                rules={{ required: "-- Pilih Salah Satu --" }}
                render={({ field }) => (
                  <Select
                    value={field.value}
                    options={courseTypeOptions}
                    onChange={(value) => field.onChange(value)}
                  />
                )}
              />
              {errors.courseType && (
                <div className="">
                  <Message
                    className="mt-2 d-flex"
                    severity="error"
                    text={errors.courseType.message}
                  />
                </div>
              )}
            </div>
          </div>

          {/* SESI */}
          {courseType.value === "TUTORIAL" && (
            <Fragment>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">Sesi</label>
                  <Controller
                    control={control}
                    name="sesi"
                    rules={{ required: "-- Pilih Salah Satu --" }}
                    render={({ field }) => (
                      <Select
                        value={field.value}
                        options={sesiOptions}
                        onChange={(value) => field.onChange(value)}
                      />
                    )}
                  />
                  {errors.sesi && (
                    <div className="">
                      <Message
                        className="mt-2 d-flex"
                        severity="error"
                        text={errors.sesi.message}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">Kasus</label>
                  <Controller
                    control={control}
                    name="courseTopic"
                    rules={{ required: "-- Pilih Salah Satu --" }}
                    render={({ field }) => (
                      <Select
                        value={field.value}
                        options={courseTopicOptions}
                        onChange={(value) => field.onChange(value)}
                      />
                    )}
                  />
                  {errors.courseTopic && (
                    <div className="">
                      <Message
                        className="mt-2 d-flex"
                        severity="error"
                        text={errors.courseTopic.message}
                      />
                    </div>
                  )}
                  <Link
                    to={{ pathname: `/akademik/courses/${courseId}` }}
                    style={{ textDecoration: "none" }}
                  >
                    + Tambah Kasus Baru
                  </Link>
                </div>
              </div>
            </Fragment>
          )}

          {/* COURSE TOPIC */}
          {courseType.value !== "TUTORIAL" && (
            <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">Topik</label>
                <Controller
                  control={control}
                  name="courseTopic"
                  rules={{ required: "-- Pilih Salah Satu --" }}
                  render={({ field }) => (
                    <Select
                      value={field.value}
                      options={courseTopicOptions}
                      onChange={(value) => field.onChange(value)}
                    />
                  )}
                />
                {errors.courseTopic && (
                  <div className="">
                    <Message
                      className="mt-2 d-flex"
                      severity="error"
                      text={errors.courseTopic.message}
                    />
                  </div>
                )}
                <Link
                  to={{ pathname: `/akademik/courses/${courseId}` }}
                  style={{ textDecoration: "none" }}
                >
                  + Tambah Topik Baru
                </Link>
              </div>
            </div>
          )}
        </div>

        {/* DATE */}
        <div className="row mb-3">
          <div className="col-md-4">
            <div className="form-group">
              <label className="form-label">Tanggal</label>
              <input
                {...register("date", {
                  required: "Tanggal tidak boleh kosong!",
                })}
                type="date"
                className="form-control"
              />
              {errors.date && (
                <div className="">
                  <Message
                    className="mt-2 d-flex"
                    severity="error"
                    text={errors.date.message}
                  />
                </div>
              )}
            </div>
          </div>

          {/* START TIME */}
          <div className="col-md-4">
            <div className="form-group">
              <label className="form-label">Waktu Mulai</label>
              <input
                {...register("start_time", {
                  required: "Waktu mulai tidak boleh kosong!",
                })}
                type="time"
                className="form-control"
              />
              {errors.start_time && (
                <div className="">
                  <Message
                    className="mt-2 d-flex"
                    severity="error"
                    text={errors.start_time.message}
                  />
                </div>
              )}
            </div>
          </div>

          {/* END TIME */}
          <div className="col-md-4">
            <div className="form-group">
              <label className="form-label">Waktu Selesai</label>
              <input
                {...register("end_time", {
                  required: "Waktu selesai tidak boleh kosong!",
                })}
                type="time"
                className="form-control"
              />
              {errors.end_time && (
                <div className="">
                  <Message
                    className="mt-2 d-flex"
                    severity="error"
                    text={errors.end_time.message}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* CLASSROOM */}
        <div className="row mb-3">
          <div className="col-md-4">
            <div className="form-group">
              <label className="form-label">Ruangan</label>
              <Controller
                control={control}
                name="classroom"
                rules={{ required: "-- Pilih Salah Satu --" }}
                render={({ field }) => (
                  <Select
                    value={field.value}
                    options={classroomOptions}
                    onChange={(value) => field.onChange(value)}
                  />
                )}
              />
              {errors.classroom && (
                <div className="">
                  <Message
                    className="mt-2 d-flex"
                    severity="error"
                    text={errors.classroom.message}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* COURSE GROUP STUDENTS */}
        {(courseType.value === "TUTORIAL" || courseType.value === "KKD") && (
          <Fragment>
            <div className="row mb-3">
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">Kelompok Modul</label>
                  <Controller
                    control={control}
                    name="kelompokModul"
                    render={({ field }) => (
                      <Select
                        placeholder="-- Pilih Salah Satu --"
                        value={field.value}
                        options={kelompokModulOptions}
                        {...field}
                      />
                    )}
                  />
                  {kelompokModul.value == 1 && (
                    <Link
                      style={{ textDecoration: "none" }}
                      onClick={unduhTemplate}
                    >
                      <i className="fas fa-file-excel"></i> Unduh Template
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </Fragment>
        )}

        {/* COURSE GROUP LECTURERS */}
        {courseType.value !== "TUTORIAL" && courseType.value !== "KKD" && (
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">Pengajar</label>
                <Controller
                  control={control}
                  name="courseLecturers"
                  rules={{ required: "-- Pilih Salah Satu --" }}
                  render={({ field }) => (
                    <Select
                      value={field.value}
                      options={courseLecturerOptions}
                      onChange={(value) => field.onChange(value)}
                    />
                  )}
                />
                {errors.courseLecturers && (
                  <div className="">
                    <Message
                      className="mt-2 d-flex"
                      severity="error"
                      text={errors.courseLecturers.message}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {courseType.value === "TUTORIAL" && kelompokModul.value === 1 && (
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">Unggah File Kelompok Tutor</label>
                <input
                  {...register("file", {
                    required: "File tidak boleh kosong!",
                  })}
                  type="file"
                  className="form-control"
                />
                {errors.file && (
                  <div className="">
                    <Message
                      className="mt-2 d-flex"
                      severity="error"
                      text={errors.file.message}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* COURSE GROUP LECTURERS */}
        {courseType.value === "TUTORIAL" && kelompokModul.value === 2 && (
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">Fasilitator</label>
                <Controller
                  control={control}
                  name="courseLecturers"
                  rules={{ required: "-- Pilih Salah Satu --" }}
                  render={({ field }) => (
                    <Select
                      value={field.value}
                      options={courseLecturerOptions}
                      onChange={(value) => field.onChange(value)}
                    />
                  )}
                />
                {errors.courseLecturers && (
                  <div className="">
                    <Message
                      className="mt-2 d-flex"
                      severity="error"
                      text={errors.courseLecturers.message}
                    />
                  </div>
                )}
              </div>
            </div>

            {/* MAHASISWA TUTORIAL */}
            <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">Mahasiswa</label>
                <Controller
                  control={control}
                  name="courseStudents"
                  rules={{ required: "-- Pilih Salah Satu --" }}
                  render={({ field }) => (
                    <Select
                      value={field.value}
                      options={courseStudentOptions}
                      isMulti
                      onChange={(value) => field.onChange(value)}
                    />
                  )}
                />
                {errors.courseStudents && (
                  <div className="">
                    <Message
                      className="mt-2 d-flex"
                      severity="error"
                      text={errors.courseStudents.message}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {courseType.value === "KKD" && kelompokModul.value === 1 && (
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">Unggah File Kelompok KKD</label>
                <input
                  {...register("file", {
                    required: "File tidak boleh kosong!",
                  })}
                  type="file"
                  className="form-control"
                />
                {errors.file && (
                  <div className="">
                    <Message
                      className="mt-2 d-flex"
                      severity="error"
                      text={errors.file.message}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* COURSE GROUP LECTURERS */}
        {courseType.value === "KKD" && kelompokModul.value === 2 && (
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">Pengajar</label>
                <Controller
                  control={control}
                  name="courseLecturers"
                  rules={{ required: "-- Pilih Salah Satu --" }}
                  render={({ field }) => (
                    <Select
                      value={field.value}
                      options={courseLecturerOptions}
                      onChange={(value) => field.onChange(value)}
                    />
                  )}
                />
                {errors.courseLecturers && (
                  <div className="">
                    <Message
                      className="mt-2 d-flex"
                      severity="error"
                      text={errors.courseLecturers.message}
                    />
                  </div>
                )}
              </div>
            </div>

            {/* MAHASISWA KKD */}
            <div className="col-md-4">
              <div className="form-group">
                <label className="form-label">Mahasiswa</label>
                <Controller
                  control={control}
                  name="courseStudents"
                  rules={{ required: "-- Pilih Salah Satu --" }}
                  render={({ field }) => (
                    <Select
                      value={field.value}
                      options={courseStudentOptions}
                      isMulti
                      onChange={(value) => field.onChange(value)}
                    />
                  )}
                />
                {errors.courseStudents && (
                  <div className="">
                    <Message
                      className="mt-2 d-flex"
                      severity="error"
                      text={errors.courseStudents.message}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          Batal
        </Button>
        <Button
          variant="success"
          disabled={loading}
          onClick={handleSubmit(handleSave)}
        >
          {loading && (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          )}
          <span className="ml-1">Simpan</span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateModal;
